import LDClient from "launchdarkly-js-client-sdk"

let client
let isClientReady = false
const getClient = (company, onReadyCallback) => {
  const context = {
    kind: 'company',
    key: `company_${company.id}`,
    is_free_trial: !company.attributes?.paid,
  }

  if (!client) {
    client = LDClient.initialize(process.env.LAUNCHDARKLY_CLIENT_ID, context)
    client.on('ready', () => {
      isClientReady = true
      if (onReadyCallback) {
        onReadyCallback()
      }
    })
  } else if(onReadyCallback){
     if(isClientReady){
      onReadyCallback()
    } else {
      client.on('ready', onReadyCallback)
    }
  }

  return client
}

const LdFeatures = {
  install(Vue, opts = {}) {
    Vue.prototype.$ldFeatures = {
      getClient,
      enabledForCompany: (feature, company) => {
        if (!company) return

        return getClient(company).variation(feature, false)
      },
    }
  },
}

export default LdFeatures
